document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('cl-header-account--popup'),
        closeBtn = document.getElementById('cl-header-account--close-btn'),
        popupContent = document.querySelector('.cl-header-account--popup-content'),
        loginForm = popupContent.querySelector('form'),
        loginBtn = loginForm.querySelector('button[type="submit"]'),
        togglePass = document.getElementById('cl-form--toggle-password'),
        passwordInput = document.getElementById('cl-form--password');

  const icons = {
      open: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><g fill="#000" fill-rule="nonzero"><g><path d="M16.84 2.987C14.57 1.07 12.206.054 10 .054c-2.206 0-4.57 1.015-6.84 2.933C2.136 3.85 1.208 4.82.392 5.881l-.27.369.272.369C1.209 7.68 2.137 8.65 3.16 9.512c2.27 1.921 4.634 2.934 6.84 2.934 2.206 0 4.57-1.015 6.84-2.934 1.024-.862 1.952-1.832 2.768-2.893l.27-.369-.272-.369c-.815-1.061-1.743-2.031-2.766-2.894zM10 11.197c-3.917 0-7.315-3.75-8.306-4.946.991-1.206 4.39-4.946 8.306-4.946 3.917 0 7.315 3.742 8.306 4.946-.99 1.206-4.381 4.946-8.306 4.946z" transform="translate(2.000000, 6.000000)"/><path d="M10 2.892c-1.845.045-3.307 1.57-3.277 3.415.031 1.845 1.544 3.32 3.389 3.304 1.845-.015 3.332-1.516 3.332-3.361-.027-1.877-1.567-3.38-3.444-3.358zm0 5.466c-1.154-.045-2.057-1.01-2.026-2.164.03-1.155.983-2.07 2.137-2.055 1.155.016 2.083.956 2.083 2.111-.026 1.187-1.007 2.13-2.194 2.108z" transform="translate(2.000000, 6.000000)"/></g></g></g></svg>`,
      close: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M630.92-441.08 586-486q9-49.69-28.35-89.35Q520.31-615 466-606l-44.92-44.92q13.54-6.08 27.77-9.12 14.23-3.04 31.15-3.04 68.08 0 115.58 47.5T643.08-500q0 16.92-3.04 31.54-3.04 14.61-9.12 27.38Zm127.23 124.46L714-358q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-46.61-46.61q37.92-15.08 77.46-22.23Q438.39-780 480-780q140.61 0 253.61 77.54T898.46-500q-22.23 53.61-57.42 100.08-35.2 46.46-82.89 83.3Zm32.31 231.39L628.62-245.85q-30.77 11.39-68.2 18.62Q523-220 480-220q-141 0-253.61-77.54Q113.77-375.08 61.54-500q22.15-53 57.23-98.88 35.08-45.89 77.23-79.58l-110.77-112 42.16-42.15 705.22 705.22-42.15 42.16Zm-552.3-551.08q-31.7 25.23-61.66 60.66Q146.54-540.23 128-500q50 101 143.5 160.5T480-280q27.31 0 54.39-4.62 27.07-4.61 45.92-9.53L529.69-346q-10.23 4.15-23.69 6.61-13.46 2.47-26 2.47-68.08 0-115.58-47.5T316.92-500q0-12.15 2.47-25.42 2.46-13.27 6.61-24.27l-87.84-86.62ZM541-531Zm-131.77 65.77Z"/></svg>`
  };

  let isPassVisible = false;
  togglePass.innerHTML = icons.open;

  togglePass.onclick = () => {
      isPassVisible = !isPassVisible;
      passwordInput.type = isPassVisible ? 'text' : 'password';
      togglePass.innerHTML = isPassVisible ? icons.close : icons.open;
  };

  document.querySelectorAll('.cl-header-account--open-popup-btn').forEach(btn => {
      btn.onclick = (e) => {
          e.preventDefault();
          popup.style.display = 'block';
          setTimeout(() => popup.classList.add('active'), 10);
          document.body.style.overflow = 'hidden';
      };
  });

  const closePopup = () => {
      popup.classList.remove('active');
      setTimeout(() => { popup.style.display = 'none'; document.body.style.overflow = ''; }, 300);
  };

  closeBtn.onclick = closePopup;

  $('#cl-header-account--popup').click(() => {
      popup.classList.remove('active');
      setTimeout(() => {
          popup.style.display = 'none';
          document.body.style.overflow = '';
      }, 300);
  });

  $('.cl-header-account--popup-content').click(e => e.stopPropagation());

//   loginForm.onsubmit = e => {
//       e.preventDefault();
//       loginForm.querySelector('.cl-header-account--error')?.remove();
//       loginBtn.disabled = true;
//       // loginBtn.innerHTML = `<span style="display:inline-block;width:18px;height:18px;border:1px solid #fff;border-top-color:transparent;border-radius:50%;animation:spin 1s linear infinite;"></span> Logging in...`;
//       loginBtn.innerHTML = `<span style="display:inline-block;width:18px;height:18px;border:1px solid #fff;border-top-color:transparent;border-radius:50%;animation:spin 1s linear infinite;"></span> ${window.location.pathname.includes('/ar') ? 'جاري تسجيل الدخول...' : 'Logging in...'}`;
//       fetch('/account/login', { method: 'POST', headers: { 'Accept': 'text/html' }, body: new FormData(loginForm) })
//           .then(res => res.text())
//           .then(txt => {
//               if (txt.includes('form-message--error') || txt.includes('Incorrect email or password')) showError('Incorrect email or password.');
//               else location.reload();
//           })
//           .catch(() => showError('Something went wrong.'));
//   };
loginForm.addEventListener('submit', () => {
    // Disable the button so user can't double click
    loginBtn.disabled = true;

    // Change button text to show loader
    loginBtn.innerHTML = `
        <span style="display:inline-block;width:18px;height:18px;border:2px solid #fff;border-top-color:transparent;border-radius:50%;animation: spin 1s linear infinite;margin-right:8px;"></span>
        ${window.location.pathname.includes('/ar') ? 'جاري تسجيل الدخول...' : 'Logging in...'}
    `;
});

  const showError = msg => {
      const err = document.createElement('div');
      err.className = 'cl-header-account--error';
      err.style.cssText = 'color:red;margin-bottom:15px';
      err.textContent = msg;
      loginForm.prepend(err);
      loginBtn.disabled = false;
      loginBtn.textContent = 'Login';
  };

  const style = document.createElement('style');
  style.innerHTML = `@keyframes spin{to{transform:rotate(360deg)}}`;
  document.head.appendChild(style);
});